import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ITextBuilder from "../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IDateBuilder from "../../../toolkit/baseForms2/iDateBuilder/IDateBuilder";

export type Inputs = "idPersona" | "nombre" | "fechaInicio" | "fechaFin";
export type Buttons = "buscar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "idPersona",
      label: "Id de Persona",
      bts: {
        mCol: 2
      },
      component: ITextBuilder,
      props: {
        type: "NUMERIC"
      }
    },
    {
      name: "nombre",
      label: "Nombre del cliente",
      bts: {
        mCol: 4
      },
      component: ITextBuilder,
      props: {
        disabled: values => !!values.idPersona
      }
    },
    {
      name: "fechaInicio",
      label: "Fecha inicial de registro",
      bts: {
        mCol: 3
      },
      component: IDateBuilder,
      props: {
        disabled: values => !!values.idPersona
      }
    },
    {
      name: "fechaFin",
      label: "Fecha final de registro",
      bts: {
        mCol: 3
      },
      component: IDateBuilder,
      props: {
        disabled: values => !!values.idPersona
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: {
        mOff: 9,
        mCol: 3
      },
      component: IButtonBuilder
    }
  ],
  rows: [["idPersona", "nombre", "fechaInicio", "fechaFin"], ["buscar"]]
};
